import React from 'react';
import S from './employableHistoryFilters.scss';
import PropTypes from 'prop-types';

const EmployableHistoryFilters = ({ toggleEventFilters, isOnlyNotes, isOnlyEditEvents,
  isAllEvents }) => <div className={S.employableHistorySortContainer}>
    <div className={S.employableHistorySortDirection}>
      Show Only Notes <input
        type="radio"
        checked={isOnlyNotes}
        onChange={() => toggleEventFilters('Notes')}
      />
    </div>
    <div className={S.employableHistorySortDirection}>
      Show Only Edit Events <input
        type="radio"
        checked={isOnlyEditEvents}
        onChange={() => toggleEventFilters('Edit Events')}
      />
    </div>
    <div className={S.employableHistorySortDirection}>
      All Events <input
        type="radio"
        checked={isAllEvents}
        onChange={() => toggleEventFilters('All')}
      />
    </div>
  </div>;

EmployableHistoryFilters.propTypes = {
  isAllEvents: PropTypes.bool,
  isOnlyNotes: PropTypes.bool,
  isOnlyEditEvents: PropTypes.bool,
  toggleEventFilters: PropTypes.func,
};

export default EmployableHistoryFilters;



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistoryFilters/index.jsx